import {
  createPlugin,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import {
  AgenticReadinessApiRef,
  AgenticReadinessApiClient,
} from './api/AgenticReadinessApi';
import { rootRouteRef } from './routes';

export const aiCodingReadinessPlugin = createPlugin({
  id: 'ai-coding-readiness',
  apis: [
    createApiFactory({
      api: AgenticReadinessApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, identityApi }) =>
        new AgenticReadinessApiClient(discoveryApi, identityApi),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AiCodingReadinessPage = aiCodingReadinessPlugin.provide(
  createRoutableExtension({
    name: 'AiCodingReadinessPage',
    component: () =>
      import('./components/AgenticReadinessPage').then(
        m => m.AgenticReadinessDashboard,
      ),
    mountPoint: rootRouteRef,
  }),
);
